import React from "react";
import { useDispatch } from "react-redux";
import { setDimension } from "../../redux/slices/carrommSlice";

const Dimension = () => {
  const dispatch = useDispatch();

  const selectDimension = (dimen) => {
    dispatch(setDimension(dimen));
  };

  return (
    <>
      <div className=" responsive-box h-screen bg-gray-100" style={{ display: "flex" }}>
        <div class="background-container">
          <div class="info-box">
            <p>
              Erfahren Sie mehr über den picDesigner <br />
              <a href="https://picDesigner.io" class="info-link">
                www.picDesigner.io
              </a>
            </p>
          </div>
        </div>
        <div
          className=" flex flex-col md:justify-center px-12"
          style={{ width: "100%" }}
        >
          <div className="dimension-container h-50 d-flex flex-column justify-content-between">
            <div>
              <h1 className="title">picDesigner - KI - Demo-Tool</h1>
              <p className="subtitle">Treffen Sie eine Auswahl</p>
            </div>

            <div className="buttons">
              <button onClick={() => selectDimension("2D")} className="button">
                2D Demo
              </button>
              <button onClick={() => selectDimension("3D")} className="button">
                3D Demo
              </button>
            </div>
            <div class="image-container">
              <img src="./assets/image/front-banner.png" alt="Logo 1" />
              <img src="./assets/image/front-banner2.jpg" alt="Logo 2" className="mix-blend-darken" />
            </div>
          </div>
        </div>
      </div>
     
    </>
  );
};

export default Dimension;
